export const userLanguage = '__user_language'

export default { userLanguage }
